import * as THREE from 'three';
import { PROFILE } from '../utils/profileConstants';

/**
 * Create a bottom sill that extends outward from the frame.
 */
export function createSill(
  totalWidth: number,
  material: THREE.Material,
): THREE.Group {
  const group = new THREE.Group();
  group.name = 'sill';

  const geo = new THREE.BoxGeometry(
    totalWidth + PROFILE.sillDepth * 0.2,
    PROFILE.sillHeight,
    PROFILE.sillDepth,
  );
  const mesh = new THREE.Mesh(geo, material);
  // Position below the frame, extending forward
  mesh.position.set(
    totalWidth / 2,
    -PROFILE.sillHeight / 2,
    PROFILE.sillDepth / 2 - PROFILE.frameDepth / 2,
  );
  mesh.castShadow = true;
  mesh.receiveShadow = true;
  group.add(mesh);

  return group;
}
